module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor11.3240474b.png";